import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Menu } from '@app/models/util/menu';

import { environment } from 'environments/environment';

@Component({
  selector: 'app-administrativo-clientes-layout',
  templateUrl: './administrativo-clientes-layout.component.html',
  styleUrls: ['./administrativo-clientes-layout.component.scss']
})
export class AdministrativoClientesLayoutComponent {
  producao: boolean = true;
  menusMap: Map<string, MenuGrupoDados> = new Map<string, MenuGrupoDados>();
  mobileX: boolean = true;

  constructor(
    public router: Router,
    private _breakpointObserver: BreakpointObserver
  ) {
    this._breakpointObserver.observe('(max-width: 390px)').subscribe((result: BreakpointState) => {
      if (result.matches) {
        this._naoAplicaResponsividadeMobile()
      } else {
        this._aplicaResponsividadeMobile()
      }
    });

    if (environment.PRODUCAO) {
      this.producao = true;
    };

    this._inicializaMenus();
  }
  
  private _inicializaMenus() {
    let menus: Menu[] = [];
    let caminhoBase: string = '/sistema/administrativo';

    menus.push(new Menu('Lista Clientes', 7, `${caminhoBase}/lista`,false,null));
    menus.push(new Menu('Novo Cliente', 7, `${caminhoBase}/novo-usuario`,false,null));

    this.menusMap.set("1", new MenuGrupoDados(
      'Administrativo', 'fa fa-wrench', menus)
    );
  }

  sair() {
    localStorage.removeItem('Cardeal.Token');
    localStorage.removeItem('Cardeal.Usuario');
    this.router.navigate(['/login']);
  }

  voltar() {
    window.history.go(-1);
  }

  private _aplicaResponsividadeMobile() {
    this.mobileX = false;
  }
  private _naoAplicaResponsividadeMobile() {
    this.mobileX = true;
  }

}

export class MenuGrupoDados { //Model replicada...
  Menus: Menu[] = [];
  Descricao: string = '';
  Icone: string = '';

  constructor(descricao: string, icone: string, menus: Menu[]) {
    this.Menus = menus;
    this.Descricao = descricao;
    this.Icone = icone;
  }
}
